var _mask, _path, _path2, _circle, _rect, _rect2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyScratch = function SvgImgEmptyScratch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 17c6.075 0 11 4.925 11 11h17a4 4 0 0 1 4 4v5a2 2 0 1 0 0 4v6a2 2 0 1 0 0 4v6a2 2 0 1 0 0 4v3a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-3a2 2 0 1 0 0-4v-6a2 2 0 1 0 0-4v-6a2 2 0 1 0 0-4v-5a4 4 0 0 1 4-4h17c0-6.075 4.925-11 11-11z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 17c6.075 0 11 4.925 11 11h17a4 4 0 0 1 4 4v5a2 2 0 1 0 0 4v6a2 2 0 1 0 0 4v6a2 2 0 1 0 0 4v3a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-3a2 2 0 1 0 0-4v-6a2 2 0 1 0 0-4v-6a2 2 0 1 0 0-4v-5a4 4 0 0 1 4-4h17c0-6.075 4.925-11 11-11z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28h-1.6a1.6 1.6 0 0 0 1.6 1.6V28zm21 9v1.6a1.6 1.6 0 0 0 1.6-1.6H72zm0 4h1.6a1.6 1.6 0 0 0-1.6-1.6V41zm0 6v1.6a1.6 1.6 0 0 0 1.6-1.6H72zm0 4h1.6a1.6 1.6 0 0 0-1.6-1.6V51zm0 6v1.6a1.6 1.6 0 0 0 1.6-1.6H72zm0 4h1.6a1.6 1.6 0 0 0-1.6-1.6V61zM8 61v-1.6A1.6 1.6 0 0 0 6.4 61H8zm0-4H6.4A1.6 1.6 0 0 0 8 58.6V57zm0-6v-1.6A1.6 1.6 0 0 0 6.4 51H8zm0-4H6.4A1.6 1.6 0 0 0 8 48.6V47zm0-6v-1.6A1.6 1.6 0 0 0 6.4 41H8zm0-4H6.4A1.6 1.6 0 0 0 8 38.6V37zm21-9v1.6a1.6 1.6 0 0 0 1.6-1.6H29zm23.6 0c0-6.959-5.641-12.6-12.6-12.6v3.2a9.4 9.4 0 0 1 9.4 9.4h3.2zM68 26.4H51v3.2h17v-3.2zm5.6 5.6a5.6 5.6 0 0 0-5.6-5.6v3.2a2.4 2.4 0 0 1 2.4 2.4h3.2zm0 5v-5h-3.2v5h3.2zm-2 2c0-.22.18-.4.4-.4v-3.2a3.6 3.6 0 0 0-3.6 3.6h3.2zm.4.4a.4.4 0 0 1-.4-.4h-3.2a3.6 3.6 0 0 0 3.6 3.6v-3.2zm1.6 7.6v-6h-3.2v6h3.2zm-2 2c0-.22.18-.4.4-.4v-3.2a3.6 3.6 0 0 0-3.6 3.6h3.2zm.4.4a.4.4 0 0 1-.4-.4h-3.2a3.6 3.6 0 0 0 3.6 3.6v-3.2zm1.6 7.6v-6h-3.2v6h3.2zm-2 2c0-.22.18-.4.4-.4v-3.2a3.6 3.6 0 0 0-3.6 3.6h3.2zm.4.4a.4.4 0 0 1-.4-.4h-3.2a3.6 3.6 0 0 0 3.6 3.6v-3.2zm1.6 4.6v-3h-3.2v3h3.2zM68 69.6a5.6 5.6 0 0 0 5.6-5.6h-3.2a2.4 2.4 0 0 1-2.4 2.4v3.2zm-56 0h56v-3.2H12v3.2zM6.4 64a5.6 5.6 0 0 0 5.6 5.6v-3.2A2.4 2.4 0 0 1 9.6 64H6.4zm0-3v3h3.2v-3H6.4zM8 62.6a3.6 3.6 0 0 0 3.6-3.6H8.4a.4.4 0 0 1-.4.4v3.2zm3.6-3.6A3.6 3.6 0 0 0 8 55.4v3.2c.22 0 .4.18.4.4h3.2zm-5.2-8v6h3.2v-6H6.4zm2-2a.4.4 0 0 1-.4.4v3.2a3.6 3.6 0 0 0 3.6-3.6H8.4zm-.4-.4c.22 0 .4.18.4.4h3.2A3.6 3.6 0 0 0 8 45.4v3.2zM6.4 41v6h3.2v-6H6.4zm2-2a.4.4 0 0 1-.4.4v3.2a3.6 3.6 0 0 0 3.6-3.6H8.4zm-.4-.4c.22 0 .4.18.4.4h3.2A3.6 3.6 0 0 0 8 35.4v3.2zM6.4 32v5h3.2v-5H6.4zm5.6-5.6A5.6 5.6 0 0 0 6.4 32h3.2a2.4 2.4 0 0 1 2.4-2.4v-3.2zm17 0H12v3.2h17v-3.2zm11-11c-6.959 0-12.6 5.641-12.6 12.6h3.2a9.4 9.4 0 0 1 9.4-9.4v-3.2z",
    fill: "#BDBDBD",
    mask: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    transform: "matrix(1 0 0 -1 40 28)",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 38.4,
    width: 41.2,
    height: 22.2,
    rx: 1.6,
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 38,
    width: 42,
    height: 23,
    rx: 2,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.223 46.453a3 3 0 0 0-5.196-3l-5.25 9.094a3 3 0 1 0 5.196 3l5.25-9.094z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.946 46.453a3 3 0 0 0-5.196-3l-5.25 9.094a3 3 0 0 0 5.196 3l5.25-9.094zM41.946 46.453a3 3 0 0 0-5.196-3l-5.25 9.094a3 3 0 0 0 5.196 3l5.25-9.094z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.946 46.453a3 3 0 0 0-5.196-3l-5.25 9.094a3 3 0 0 0 5.196 3l5.25-9.094z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyScratch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-scratch.4f0552e396b00d7f2454667cccb05368.svg";